export default __webpack_public_path__ + "static/media/pictogramBeaconMoneyIn128.ef79d627.svg";